import { render, staticRenderFns } from "./AS_Header.vue?vue&type=template&id=54b79868&scoped=true&"
import script from "./AS_Header.vue?vue&type=script&scoped=true&lang=js&"
export * from "./AS_Header.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./AS_Header.vue?vue&type=style&index=0&id=54b79868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b79868",
  null
  
)

export default component.exports